import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { IPartnersCompleteness } from '../../models/IPartnersCompleteness'

import { PartnersCompletenessDialogContent } from './PartnersCompletenessDialogContent'

interface IProps {
  isShowDialog: boolean
  partnersCompleteness?: IPartnersCompleteness
  onConfirm: () => void
  onClose: () => void
}

export const PartnersCompletenessDialog = ({
  isShowDialog,
  partnersCompleteness,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { partnersCompleteness, onConfirm, onClose }
  }, [partnersCompleteness, onConfirm, onClose])

  return (
    <ModalDialog
      size={'md'}
      show={isShowDialog}
      content={PartnersCompletenessDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
